/**
 * SOLID Review
 * S — Strong. One concern: what the 3D scene's WebGL runtime has done — the canvas made, the context lost, the frames drawn and the
 *     context's last numbers — for the `?gldebug` overlay and the lost-context recovery.
 * O — Good. A new counter is one more field and its line in the probe.
 * L — N/A — no hierarchy.
 * I — Strong. Its fields, and one probe a frame.
 * D — Strong. The WebGL context's shape it reads; imports nothing.
 */

/** What a frame's probe reads of the WebGL context. */
export interface IEntityGlContext {
  getError(): number;
  readonly drawingBufferWidth: number;
  readonly drawingBufferHeight: number;
  readonly canvas: unknown;
}

/**
 * THE 3D SCENE'S RUNTIME (frontend-framework-oo P4, 2026-10-29, §28.296) — `GameScene.tsx`'s module-level `glRuntime` until P4, which
 * the canvas's creation, its lost-context handler, the debug probe's frames and the recovery wrote and the debug overlay read. One per
 * factory now — one per page, as the module's was: a context lost before the scene remounts is still lost after it.
 */
export class SceneRuntime {
  created = false;
  contextLost = false;
  frames = 0;
  lastErr = 0;
  dbW = 0;
  dbH = 0;
  clientW = 0;
  clientH = 0;

  /** One frame of the `?gldebug` probe: the frame counted, the context's numbers read. */
  probe(context: IEntityGlContext): void {
    this.frames++;
    this.lastErr = context.getError();
    this.dbW = context.drawingBufferWidth;
    this.dbH = context.drawingBufferHeight;
    const canvas = context.canvas as { readonly clientWidth: number; readonly clientHeight: number };
    this.clientW = canvas.clientWidth;
    this.clientH = canvas.clientHeight;
  }
}
